<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-headphones" />
          <h5 class="d-inline ml-2">VoIP Accounts</h5>
          <div class="card-header-actions">
            <CButton color="info" @click="refreshAccounts">
              <CIcon name="cil-sync" class="align-bottom mr-1" />
              <strong>Refresh</strong>
            </CButton>
          </div>
        </CCardHeader>

        <BackendTable ref="backendTable" />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "VoIPAccounts",
  components: {
    BackendTable,
  },
  methods: {
    refreshAccounts() {
      this.$refs.backendTable?.getAllItems();
    }
  }
};
</script>
